// extracted by mini-css-extract-plugin
module.exports = {"msg":"category-form_msg_2Oo4F","subicon":"category-form_subicon_2XGHC"};